import axios from 'axios'
import { ref } from 'vue'

export function useZohoInvoices({
    onDeleted = () => {},
    onError = () => {},
}) {
    const deleting = ref(false)

    const deleteZohoInvoice = async (id) => {
        try {
            deleting.value = true
            await axios.delete(`/api/zoho-invoices/${id}`)
            onDeleted()
        } catch (error) {
            onError(error)
        } finally {
            deleting.value = false
        }
    }

    return {
        deleting,
        deleteZohoInvoice,
    }
}
